// Stale-after-save sweep (PR #648) — shared query keys for the PIR surfaces.
// The list and detail roots predate this factory ("pirs" vs "pir") and are
// kept verbatim so no existing cache entries are orphaned.

export const pirKeys = {
  list: ["pirs"] as const,
  detail: (id: string | undefined) => ["pir", id] as const,
};
